module.exports = __webpack_public_path__ + "img/manage-inprogress-icon.0848828d.svg";